import { CardListFieldsFragment } from "src/generated/graphql";
import { highlightBracketedText, highlightUnderscoreText } from "src/utils/utils";
import DynamicMedia from "src/components/shared/DynamicMedia";
import BgGradient from "src/images/Ellipse_2047.png";
import BgGradient2 from "src/images/Ellipse_2048.png";
import BgGradient3 from "src/images/Ellipse_2049.png";
type SuperChargingProps = {
  content: CardListFieldsFragment;
};

const CardList = ({ content }) => {
  const {cardsCollection } = content;
  const items = cardsCollection?.items ?? [];

  if (!content) return null;

  return (
    <div className="features-section" style={{position:"relative",zIndex:2}}>
       {[BgGradient, BgGradient3, BgGradient2,BgGradient3,BgGradient2,BgGradient].map((gradient, index) => {
            const topPositions = [0, 250, 1000,1500,2000,3000,3500];
            return (
              <img
                key={`gradient${index + 1}`}
                src={gradient}
                style={{
                  zIndex: 1,
                  width: "100%",
                  height: "33.33%",
                  left: 0,
                  top: `${topPositions[index]}px`,
                  position: "absolute",
                }}
                alt={`gradient${index + 1}`}
              />
            );
          })}
      <div className="container-fluid custom-spacer-col features-space">
        <div className="feature-inner feature-inner-industry" >
         
          <div className="features-inner-section" style={{zIndex:100,maxWidth:"1280px"}}>
            {items.map((item, index) => {
              const listItems =
                item?.subDescription?.json?.content
                  ?.filter((val) => val.nodeType === "unordered-list")[0]
                  ?.content?.map(
                    (item) => item?.content[0]?.content[0]?.value
                  ) || [];

              return (
                <div key={item.sys.id} className="feature-box">
                  <div className="features-inner-image-industry">
                    <DynamicMedia
                      src={item?.cardImage?.url ?? ""}
                      alt={item?.cardImage?.title ?? ""}
                      ariaLabel={item?.cardImage?.title ?? ""}
                      lottieProps={{
                        loop: true,
                        style: {
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          transform: "unset",
                        },
                      }}
                      lottieClassName="feature-lottie"
                    />
                  </div>
                  <div className="feature-inner-content" style={{paddingLeft:0 , paddingRight:0}}>
                    <div className="feature-head feature-industry">
                      <h3
                        dangerouslySetInnerHTML={{
                          __html: highlightBracketedText(
                            item.cardEyebrowText ?? "",
                            "bold"
                          ),
                        }}
                      />
                      <h2>{item.cardTitle}</h2>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: highlightUnderscoreText(
                            item?.cardDescription?.json?.content[0]?.content[0]
                              ?.value ?? ""
                          ),
                        }}
                      />
                    </div>
                    <ul className="feature-list">
                      {listItems.map((listItem, i) => (
                        <li key={i}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M16.909 8.72725L10.3635 15.2727L7.63628 12.5454M16.909 8.72725L10.3635 15.2727M22.909 12C22.909 18.0249 18.0248 22.9091 11.9999 22.9091C5.97499 22.9091 1.09082 18.0249 1.09082 12C1.09082 5.97505 5.97499 1.09088 11.9999 1.09088C18.0248 1.09088 22.909 5.97505 22.909 12Z"
                              stroke="#8773DA"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              fill="#CDCDF3"
                            />
                            <path
                              d="M16.909 8.72729L10.3635 15.2727L7.63623 12.5455"
                              stroke="#8773DA"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <span className="font-medium">{listItem}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
       
      </div>
    </div>
  );
};

export default CardList;
